export const SortTypes = {
    DEFAULT: "Default",
    CLIENT_NAME: "FirstName",
    ROLE: "PrimaryJobTitle",
    NEW: "New",
    IN_PROGRESS: "InProgress",
    COMPLETED: "Filed",
    AVG_COMPLETION: "AverageFileTime",
}